import {RAFI_DEVICE_STOCK_ENV_KEY} from '../../../../components/updatejobs/consts';
import {ContextInfoProps} from '@deviceinsight/ng-ui-scale-lib/api';

export const isRafiDeviceStockAssetGroup = (context: ContextInfoProps['contextInfo'] | null | undefined) => {
	const assetGroupId = window.runtimeEnv[RAFI_DEVICE_STOCK_ENV_KEY] || import.meta.env[RAFI_DEVICE_STOCK_ENV_KEY];

	if (!context || context.type !== 'assetGroup' || !context.assetGroup || !assetGroupId) {
		return false;
	}

	return assetGroupId === context.assetGroup.name;
};
